import React from 'react'
import PropTypes from 'prop-types'

import Footer from 'components/layout/Footer/Footer'
import SkipContent from 'components/_new/ada/SkipContent/SkipContent'
import Breadcrumbs from 'components/ui/breadcrumbs/Breadcrumbs/Breadcrumbs'
import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import QueueWidgetConductor from 'components/queueNonSubscribed/QueueWidgetConductor/QueueWidgetConductor'

import Banner from './Banner/Banner'
import Header from './Header/Header'

import s from './InsideLayout.scss'


const InsideLayout = ({ children, withBanner = true, withSearchInput = true, withSubHeader, withBreadcrumbs }) => (
  <div className={s.wrapper}>
    <SkipContent contentId="mainContent" />
    {
      withBanner && (
        <Banner />
      )
    }
    <div className={s.headerContainer}>
      <Header {...{ withSubHeader, withSearchInput }} />
    </div>
    <main className={s.contentContainer} id="mainContent" role="main">
      {
        withBreadcrumbs && (
          <WidthContainer className={s.breadcrumbs}>
            <Breadcrumbs />
          </WidthContainer>
        )
      }
      {children}
    </main>
    <Footer />
    <QueueWidgetConductor />
  </div>
)

InsideLayout.propTypes = {
  withSubHeader: PropTypes.bool,
  withBanner: PropTypes.bool,
  children: PropTypes.node,
}


export default InsideLayout
